var map = {
	"./Ambient_Piano__BPM70.wav": 2148,
	"./Chill_Beats__BPM80.wav": 4684,
	"./HipHop__BPM78.wav": 9977,
	"./HipHop__BPM98.wav": 771,
	"./Lofi_Hip_Hop__BPM105.wav": 1431,
	"./Lofi_Hip_Hop__BPM110.wav": 5898,
	"./Lofi_Hip_Hop__BPM145.wav": 9371,
	"./Lofi_Hip_Hop__BPM70.wav": 7963,
	"./Lofi_Hip_Hop__BPM85.wav": 4087,
	"./Lofi_Hip_Hop__BPM90.wav": 9379,
	"./Lofi_Hip_Hop__BPM95.wav": 5130,
	"./Lofihiphop__BPM75.wav": 6443,
	"./Lofihiphop__BPM80.wav": 5365,
	"./Lofihiphop__BPM85.wav": 6535,
	"./Lofihiphop__BPM95.wav": 8530,
	"./Rnb__BPM90.wav": 8359,
	"./Tokyo_Night_Pop__BPM120.wav": 2353,
	"./Tokyo_Night_Pop__BPM132.wav": 879,
	"./Tokyo_Night_Pop__BPM90.wav": 8995,
	"./Tokyo_Night_Pop__BPM97.wav": 6285,
	"./Tokyonightpop__BPM90.wav": 6035,
	"./Type_Beat__BPM90.wav": 3406,
	"./ai-one.mp3": 7885,
	"./ai-two.mp3": 3890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7717;